import request from '@/utils/request';
/**
 * 修改排序
 */
export function updateSortApi(params) {
  return request({
    url: "/admin/store/product/updateSort/".concat(params.id, "/").concat(params.sort),
    method: 'GET'
  });
}